// assets/cm-order-notice.js
// Gates the checkout buttons (cart page + cart drawer) behind the "Important
// Order Notice" checkbox until a real terms/conditions page replaces it.
(function () {
  function syncCheckbox(checkbox) {
    if (!checkbox) return;
    const targetId = String(checkbox.dataset.checkoutTarget || "").trim();
    const btn = targetId ? document.getElementById(targetId) : null;
    if (btn) btn.disabled = !checkbox.checked;
  }

  function syncAll() {
    document.querySelectorAll(".cm-order-notice-checkbox").forEach(syncCheckbox);
  }

  document.addEventListener("change", (e) => {
    const checkbox = e.target.closest(".cm-order-notice-checkbox");
    if (checkbox) syncCheckbox(checkbox);
  });

  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!form || (form.id !== "cart" && form.id !== "CartDrawer-Form")) return;

      const targetId = form.id === "cart" ? "checkout" : "CartDrawer-Checkout";
      const checkbox = document.querySelector(
        '.cm-order-notice-checkbox[data-checkout-target="' + targetId + '"]'
      );
      if (checkbox && !checkbox.checked) {
        e.preventDefault();
        checkbox.focus();
        if (checkbox.closest(".cm-order-notice")?.scrollIntoView) {
          checkbox.closest(".cm-order-notice").scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    },
    true
  );

  // Cart sections re-render wholesale on every quantity change/add/remove,
  // which wipes out the checked state along with any disabled attribute the
  // server set -- re-sync after every such mutation rather than only once.
  const observer = new MutationObserver(() => syncAll());
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncAll, { once: true });
  } else {
    syncAll();
  }
})();
